module.exports = __webpack_public_path__ + "static/salesforce-7efc641f4d6a2a4720f435a6e6887a5e.svg";